import { render, staticRenderFns } from "./LmUserProfile.vue?vue&type=template&id=55e37381&scoped=true&"
import script from "./LmUserProfile.vue?vue&type=script&lang=js&"
export * from "./LmUserProfile.vue?vue&type=script&lang=js&"
import style0 from "./LmUserProfile.vue?vue&type=style&index=0&id=55e37381&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55e37381",
  null
  
)

export default component.exports